import React, { useState } from 'react';
import { NavigationDrawer } from './NavigationDrawer';
import { Hamburger } from './Hamburger';

export function SideMenuMobileForCourier(): JSX.Element {
  const [sideNavIsOpen, setSideNavIsOpen] = useState(false);
  const navLinks = [
    { to: '/my-shift', text: 'Shift' },
    { to: '/my-deliveries', text: 'My deliveries' },
    { to: '/my-deliveries-old', text: 'My deliveries (old)' },
    { to: '/my-tips', text: 'Tips&Help' },
    { to: '/hub', text: 'Hub scan' },
    { to: '/hub/pre-sort', text: 'Pre sort scanner' },
    { to: '/hub/geo-pre-sort', text: 'Geo Pre sort scanner' },
    { to: '/hub/reg-pre-sort', text: 'Region sort scanner' },
    { to: '/my-rating', text: 'My Rating' },
    { to: '/my-rating-old', text: 'My Rating (old)' },
  ];

  return (
    <>
      <Hamburger
        onClick={() => setSideNavIsOpen(true)}
        isActive={sideNavIsOpen}
      />

      <NavigationDrawer
        close={() => setSideNavIsOpen(false)}
        open={() => setSideNavIsOpen(true)}
        isOpen={sideNavIsOpen}
        navLinks={navLinks}
      />
    </>
  );
}

export function SideMenuMobileForCourierLimited(): JSX.Element {
  const [sideNavIsOpen, setSideNavIsOpen] = useState<boolean>(false);
  const navLinks = [
    { to: '/my-shift', text: 'Shift' },
    { to: '/hub', text: 'Hub scan' },
    { to: '/my-rating', text: 'My Rating' },
    { to: '/my-rating-old', text: 'My Rating (old)' },
    { to: '/my-deliveries', text: 'My deliveries' },
  ];

  return (
    <>
      <Hamburger
        onClick={() => setSideNavIsOpen(true)}
        isActive={sideNavIsOpen}
      />

      <NavigationDrawer
        close={() => setSideNavIsOpen(false)}
        open={() => setSideNavIsOpen(true)}
        isOpen={sideNavIsOpen}
        navLinks={navLinks}
      />
    </>
  );
}
